import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';

export default function SupportPage() {
  const { t } = useTranslation();

  const faqs = [
    { q: t('support.faq1Q'), a: t('support.faq1A') },
    { q: t('support.faq2Q'), a: t('support.faq2A') },
    { q: t('support.faq3Q'), a: t('support.faq3A') },
  ];

  return (
    <div className="page">
      <Navbar />
      <div className="container" style={{ paddingTop: 28, paddingBottom: 60 }}>
        <h1 className="page-title">{t('support.title')}</h1>
        <p className="page-subtitle">{t('support.subtitle')}</p>

        <div className="card" style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: '0.78rem', color: 'var(--muted)', marginBottom: 6 }}>{t('support.emailLabel')}</div>
          <a
            href="mailto:support@tuttoclaro.com"
            style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--primary)', textDecoration: 'none' }}
          >
            support@tuttoclaro.com
          </a>
        </div>

        <div className="section-header">
          <div className="section-title">{t('support.faqTitle')}</div>
        </div>

        {faqs.map((faq, i) => (
          <div key={i} className="card" style={{ marginBottom: 10 }}>
            <div style={{ fontWeight: 700, fontSize: '0.88rem', marginBottom: 6 }}>{faq.q}</div>
            <div style={{ fontSize: '0.82rem', color: 'var(--muted)', lineHeight: 1.6 }}>{faq.a}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
